module.exports = __webpack_public_path__ + "img/am1.7edfaa28.png";